import React from 'react';
import {connect} from "react-redux";

import RetailerEntry from "./RetailerEntry";

import {
    updateRetailerSearchQuery,
    getRetailers,
    deleteRetailer,
    fetchStoresAndRetailers,
    updateRetailerGln,
    createNewRetailer,
    updateRetailerName
} from './reducer';
import CreateRetailerModal from "./CreateRetailerModal";
import SearchField from "../components/SearchField";

export class RetailerManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            retailerModalVisible: false
        };

        this.showRetailerModal = this.showRetailerModal.bind(this);
        this.hideRetailerModal = this.hideRetailerModal.bind(this);
        this.createNewRetailer = this.createNewRetailer.bind(this);
        this.handleQueryChange = this.handleQueryChange.bind(this);
    }

    handleQueryChange(query) {
        this.props.updateRetailerSearchQuery(query);
    }

    componentDidMount() {
        this.props.fetchStoresAndRetailers();
    }

    showRetailerModal() {
        this.setState({retailerModalVisible: true});
    }

    hideRetailerModal() {
        this.setState({retailerModalVisible: false});
    }

    createNewRetailer(retailer) {
        this.props.createNewRetailer(retailer);
        this.hideRetailerModal();
    }

    render() {
        return (
            <div className="animated fadeIn">
                <CreateRetailerModal visible={this.state.retailerModalVisible}
                                  onSubmit={this.createNewRetailer}
                                  onCancel={this.hideRetailerModal}/>
                <div className="row">
                    <div className="col">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Händler</h4>
                                <div className="row">
                                    <div className="col-3">
                                        <SearchField className="mb-2 mr-sm-2 mb-sm-0"
                                                     value={this.props.searchQuery}
                                                     onCommit={this.handleQueryChange}/>
                                    </div>
                                    <div className="col-9">
                                        <button type="button" className="btn btn-light float-right"
                                                onClick={this.showRetailerModal}>
                                            <i className="fa fa-plus-circle"/>&nbsp;neuer Händler
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <table className="table table-striped">
                                            <thead>
                                            <tr>
                                                <th>Händler-GLN</th>
                                                <th>Händlername</th>
                                                <th>Aktionen</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.props.retailers.map((retailer) => <RetailerEntry {...retailer}
                                                                                                   key={retailer.gln}
                                                                                                   deleteRetailer={this.props.deleteRetailer}
                                                                                                   updateRetailerGln={this.props.updateRetailerGln}
                                                                                                   updateRetailerName={this.props.updateRetailerName}
                                            />)}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        retailers: state.retailer.get('retailers') ? getRetailers(state.retailer).toJS() : [],
        searchQuery: state.retailer.get('retailerSearchQuery')
    };
}

const ConnectedRetailerManager =
    connect(mapStateToProps, {
        updateRetailerSearchQuery,
        getRetailers,
        fetchStoresAndRetailers,
        updateRetailerGln,
        deleteRetailer,
        createNewRetailer,
        updateRetailerName
    })(RetailerManager);

export default ConnectedRetailerManager;



// WEBPACK FOOTER //
// ./src/admin/retailer/RetailerManager.js